import { BrandMark } from './BrandMark';

export function StatusScreen({ error, onRetry }: { error?: string; onRetry?: () => void }) {
  return (
    <main className="status-screen">
      <BrandMark />
      {error ? <><span className="status-code">TV-DATA-01</span><h1>Não conseguimos carregar a programação.</h1><p>{error}</p><button className="primary-button" onClick={onRetry}>Tentar novamente</button></> : <><span className="spinner" /><h1>Preparando sua TV…</h1><p>Carregando canais e programação.</p></>}
    </main>
  );
}

